import { useSWR } from '@tiger/swr';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import ErrorBox from 'components/ErrorBox';
import Loading from 'components/Loading';
import { getAccountAndBankInfo } from '../../request';
import { BankSecuritiesGuideBankInfo } from '../../type';
import Item from './Item';

interface BankInfoProps {
    currency: string;
    bankId: string;
}

const BankInfo: React.FC<BankInfoProps> = ({ currency, bankId }) => {
    const navigate = useNavigate();
    const {
        error,
        data: bankInfo,
        mutate,
        isLoading
    } = useSWR<BankSecuritiesGuideBankInfo>(`deposit.wire.remittance.bankInfo.${currency}.${bankId}`, {
        fetcher: () => getAccountAndBankInfo(bankId),
        shouldRetryOnError: false
    });

    const handleUploadDetails = () => {
        navigate('../notice', {
            state: {
                currency,
                ...bankInfo?.accData
            }
        });
    };

    return (
        <div className="remittance-bank-info">
            <div className="step-box">
                <h3 className="step-title">
                    <span className="step">3</span>
                    {__('收款信息')}
                </h3>
            </div>
            <div className="tips">
                {__('请向您的银行提供以下信息发起电汇入金。')}
                {__('资金应来自您本人的银行账户。')}
                {__('TradeUP不接受第三方汇款。')}
            </div>
            <div className="mt-3">
                {isLoading ? (
                    <Loading />
                ) : error ? (
                    <ErrorBox error={error} onClick={() => mutate()} />
                ) : (
                    <>
                        <div className="bank-info-list">
                            {bankInfo?.acclist?.map((item, index) => (
                                <Item key={index} {...item} />
                            ))}
                        </div>
                        <Button className="btn-important" type="primary" block onClick={handleUploadDetails}>
                            {__('Upload transfer details(Optional)')}
                        </Button>
                    </>
                )}
            </div>
        </div>
    );
};

export default BankInfo;
